import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Mobile = React.lazy(() => import("../components/Mobile"));

const Navbar = () => {
  return (
    <header className="relative -mb-32 z-20">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between md:py-8 px-4 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="sr-only">Reardon Web Development</span>
            <StaticImage
              className="w-40"
              src="../images/Asset 1.png"
              alt="Web Designer and Developer - Reardon Web Development Logo"
              loading="eager"
              placeholder="blurred"
              quality={100}
            />
          </Link>
        </div>
        <div>
          <div className="hidden md:flex w-full  flex-col md:flex-row items-center justify-between gap-10 uppercase font-montreal-medium tracking-widest text-slate-700 text-sm">
            <Link
              to="/about"
              className="hover"
              aria-current="page"
              title="Learn more about by Reardon Web Development"
            >
              About
            </Link>
            <Link
              to="/services"
              className="hover"
              aria-current="page"
              title="Web Development Services by Reardon Web Development"
            >
              Services
            </Link>
            <Link
              to="/portfolio"
              className="hover"
              aria-current="page"
              title="Previous Web Development and Web Design Clients by Reardon Web Development"
            >
              Portfolio
            </Link>{" "}
            <Link
              to="/blog"
              className="hover"
              aria-current="page"
              title="The Reardon Web Development Blog"
            >
              Blog
            </Link>
            <Link
              to="/contact"
              className="hover"
              aria-current="page"
              title="Get in touch with Reardon Web Development"
            >
              Contact
            </Link>
            {/* <Link
              to="/contact"
              className="relative inline-block px-4 py-2 font-montreal group rounded-3xl "
            >
              <button className="button !tracking-widest px-6 py-3 font-medium bg-brand-alt text-white w-fit transition-all shadow-[3px_3px_0px_black] hover:shadow-none hover:translate-x-[3px] hover:translate-y-[3px] rounded-full font-montreal-bold border border-black uppercase text-xs ">
                Request Consultation
              </button>
            </Link> */}
          </div>
          <Mobile />
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
